<template>
  <v-card max-width="100%" outlined>
    <v-app-bar dark dense color="red lighten-1" elevation="0">
      <v-toolbar-title>Lista de Notas Fiscais</v-toolbar-title>
      <NewInvoiceForm />
    </v-app-bar>
    <v-data-table
      :headers="headers"
      :items="invoices"
      :items-per-page="6"
      :search="search"
      :custom-filter="filterItems"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-col class="d-flex justify-end">
            <InvoiceDetailing :externalAccess="false" :invoiceId="item.id" />
          </v-col>
          <!-- <v-col class="d-flex justify-end">
            <v-btn text medium icon @click="modalDeleteItem(item.id)">
              <v-icon medium color="red lighten-1"> mdi-close-box-outline </v-icon>
            </v-btn>
          </v-col> -->
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import NewInvoiceForm from '@/views/invoice/components/NewInvoiceForm'
import InvoiceDetailing from '@/views/invoice/components/InvoiceDetailing'

export default {
  name: 'ListInvoices',
  components: { NewInvoiceForm, InvoiceDetailing },
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Numero NF',
          align: 'start',
          value: 'nf_number',
        },
        { text: 'Fornecedor', value: 'provider' },
        { text: 'Data da Compra', value: 'acquisition_date' },
        // { text: 'Preço Total', value: '' },
        { text: '', value: 'actions', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('acquisitions', ['invoices']),
  },
  methods: {
    filterItems(value, search, item) {
      search = search.toUpperCase()

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      )
    },
  },
}
</script>